import { shallowRef, computed } from 'vue';
import { defineStore } from 'pinia';
import type { GeneratedSummary } from '../types';

/**
 * This store manages the state for the AI-generated review summary feature.
 */

/**
 * Pinia store for managing reviews that contain photos.
 * @returns {{
 *  generatedSummary: import('vue').ShallowRef<GeneratedSummary | null>,
 *  isBulletSummary: import('vue').ComputedRef<boolean>
 * }}
 */
const useReviewsSummaryStore = defineStore('reviewsSummaryStore', () => {
  // state
  const generatedSummary = shallowRef<GeneratedSummary | null>(null);

  // getters
  /**
   * Checks if the current AI summary is in a bullet-point format.
   * @type {import('vue').ComputedRef<boolean>}
   */
  const isBulletSummary = computed<boolean>(() => {
    return (
      generatedSummary.value?.detail === 'BULLET_FORMAT_SUMMARY' || !!(generatedSummary.value && 'totalReviewsAtSummary' in generatedSummary.value)
    );
  });

  return {
    // state
    generatedSummary,
    // getters
    isBulletSummary,
  };
});

export default useReviewsSummaryStore;
